/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
  type WritableSignerAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS } from '../programs';

export const CLAIM_FEES_DISCRIMINATOR = new Uint8Array([
  82, 251, 233, 156, 12, 52, 184, 202,
]);

export function getClaimFeesDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(CLAIM_FEES_DISCRIMINATOR);
}

export type ClaimFeesInstruction<
  TProgram extends string = typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
  TAccountPayer extends string | AccountMeta<string> = string,
  TAccountBeneficiary extends string | AccountMeta<string> = string,
  TAccountRehypeState extends string | AccountMeta<string> = string,
  TAccountRehypeAuthority extends string | AccountMeta<string> = string,
  TAccountBaseMint extends string | AccountMeta<string> = string,
  TAccountQuoteMint extends string | AccountMeta<string> = string,
  TAccountRouterBaseAta extends string | AccountMeta<string> = string,
  TAccountRouterQuoteAta extends string | AccountMeta<string> = string,
  TAccountBeneficiaryBaseAta extends string | AccountMeta<string> = string,
  TAccountBeneficiaryQuoteAta extends string | AccountMeta<string> = string,
  TAccountBaseTokenProgram extends string | AccountMeta<string> = string,
  TAccountQuoteTokenProgram extends string | AccountMeta<string> = string,
  TAccountAssociatedTokenProgram extends string | AccountMeta<string> =
    'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL',
  TAccountSystemProgram extends string | AccountMeta<string> =
    '11111111111111111111111111111111',
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountPayer extends string
        ? WritableSignerAccount<TAccountPayer> &
            AccountSignerMeta<TAccountPayer>
        : TAccountPayer,
      TAccountBeneficiary extends string
        ? ReadonlyAccount<TAccountBeneficiary>
        : TAccountBeneficiary,
      TAccountRehypeState extends string
        ? WritableAccount<TAccountRehypeState>
        : TAccountRehypeState,
      TAccountRehypeAuthority extends string
        ? ReadonlyAccount<TAccountRehypeAuthority>
        : TAccountRehypeAuthority,
      TAccountBaseMint extends string
        ? ReadonlyAccount<TAccountBaseMint>
        : TAccountBaseMint,
      TAccountQuoteMint extends string
        ? ReadonlyAccount<TAccountQuoteMint>
        : TAccountQuoteMint,
      TAccountRouterBaseAta extends string
        ? WritableAccount<TAccountRouterBaseAta>
        : TAccountRouterBaseAta,
      TAccountRouterQuoteAta extends string
        ? WritableAccount<TAccountRouterQuoteAta>
        : TAccountRouterQuoteAta,
      TAccountBeneficiaryBaseAta extends string
        ? WritableAccount<TAccountBeneficiaryBaseAta>
        : TAccountBeneficiaryBaseAta,
      TAccountBeneficiaryQuoteAta extends string
        ? WritableAccount<TAccountBeneficiaryQuoteAta>
        : TAccountBeneficiaryQuoteAta,
      TAccountBaseTokenProgram extends string
        ? ReadonlyAccount<TAccountBaseTokenProgram>
        : TAccountBaseTokenProgram,
      TAccountQuoteTokenProgram extends string
        ? ReadonlyAccount<TAccountQuoteTokenProgram>
        : TAccountQuoteTokenProgram,
      TAccountAssociatedTokenProgram extends string
        ? ReadonlyAccount<TAccountAssociatedTokenProgram>
        : TAccountAssociatedTokenProgram,
      TAccountSystemProgram extends string
        ? ReadonlyAccount<TAccountSystemProgram>
        : TAccountSystemProgram,
      ...TRemainingAccounts,
    ]
  >;

export type ClaimFeesInstructionData = {
  discriminator: ReadonlyUint8Array;
  beneficiaryIndex: number;
};

export type ClaimFeesInstructionDataArgs = { beneficiaryIndex: number };

export function getClaimFeesInstructionDataEncoder(): FixedSizeEncoder<ClaimFeesInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', fixEncoderSize(getBytesEncoder(), 8)],
      ['beneficiaryIndex', getU8Encoder()],
    ]),
    (value) => ({ ...value, discriminator: CLAIM_FEES_DISCRIMINATOR }),
  );
}

export function getClaimFeesInstructionDataDecoder(): FixedSizeDecoder<ClaimFeesInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
    ['beneficiaryIndex', getU8Decoder()],
  ]);
}

export function getClaimFeesInstructionDataCodec(): FixedSizeCodec<
  ClaimFeesInstructionDataArgs,
  ClaimFeesInstructionData
> {
  return combineCodec(
    getClaimFeesInstructionDataEncoder(),
    getClaimFeesInstructionDataDecoder(),
  );
}

export type ClaimFeesAsyncInput<
  TAccountPayer extends string = string,
  TAccountBeneficiary extends string = string,
  TAccountRehypeState extends string = string,
  TAccountRehypeAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountRouterBaseAta extends string = string,
  TAccountRouterQuoteAta extends string = string,
  TAccountBeneficiaryBaseAta extends string = string,
  TAccountBeneficiaryQuoteAta extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountAssociatedTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
> = {
  payer: TransactionSigner<TAccountPayer>;
  beneficiary: Address<TAccountBeneficiary>;
  rehypeState?: Address<TAccountRehypeState>;
  rehypeAuthority?: Address<TAccountRehypeAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  routerBaseAta?: Address<TAccountRouterBaseAta>;
  routerQuoteAta?: Address<TAccountRouterQuoteAta>;
  beneficiaryBaseAta?: Address<TAccountBeneficiaryBaseAta>;
  beneficiaryQuoteAta?: Address<TAccountBeneficiaryQuoteAta>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  associatedTokenProgram?: Address<TAccountAssociatedTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  beneficiaryIndex: ClaimFeesInstructionDataArgs['beneficiaryIndex'];
};

export async function getClaimFeesInstructionAsync<
  TAccountPayer extends string,
  TAccountBeneficiary extends string,
  TAccountRehypeState extends string,
  TAccountRehypeAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountRouterBaseAta extends string,
  TAccountRouterQuoteAta extends string,
  TAccountBeneficiaryBaseAta extends string,
  TAccountBeneficiaryQuoteAta extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountAssociatedTokenProgram extends string,
  TAccountSystemProgram extends string,
  TProgramAddress extends Address =
    typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
>(
  input: ClaimFeesAsyncInput<
    TAccountPayer,
    TAccountBeneficiary,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBeneficiaryBaseAta,
    TAccountBeneficiaryQuoteAta,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  ClaimFeesInstruction<
    TProgramAddress,
    TAccountPayer,
    TAccountBeneficiary,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBeneficiaryBaseAta,
    TAccountBeneficiaryQuoteAta,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram
  >
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    payer: { value: input.payer ?? null, isWritable: true },
    beneficiary: { value: input.beneficiary ?? null, isWritable: false },
    rehypeState: { value: input.rehypeState ?? null, isWritable: true },
    rehypeAuthority: {
      value: input.rehypeAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    routerBaseAta: { value: input.routerBaseAta ?? null, isWritable: true },
    routerQuoteAta: { value: input.routerQuoteAta ?? null, isWritable: true },
    beneficiaryBaseAta: {
      value: input.beneficiaryBaseAta ?? null,
      isWritable: true,
    },
    beneficiaryQuoteAta: {
      value: input.beneficiaryQuoteAta ?? null,
      isWritable: true,
    },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    associatedTokenProgram: {
      value: input.associatedTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.rehypeState.value) {
    accounts.rehypeState.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            114, 101, 104, 121, 112, 101, 95, 115, 116, 97, 116, 101,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.rehypeAuthority.value) {
    accounts.rehypeAuthority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            114, 101, 104, 121, 112, 101, 95, 97, 117, 116, 104, 111, 114, 105,
            116, 121,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeState',
            accounts.rehypeState.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.routerBaseAta.value) {
    accounts.routerBaseAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeAuthority',
            accounts.rehypeAuthority.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseTokenProgram',
            accounts.baseTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.routerQuoteAta.value) {
    accounts.routerQuoteAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeAuthority',
            accounts.rehypeAuthority.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteTokenProgram',
            accounts.quoteTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteMint',
            accounts.quoteMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.beneficiaryBaseAta.value) {
    accounts.beneficiaryBaseAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'beneficiary',
            accounts.beneficiary.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseTokenProgram',
            accounts.baseTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.beneficiaryQuoteAta.value) {
    accounts.beneficiaryQuoteAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'beneficiary',
            accounts.beneficiary.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteTokenProgram',
            accounts.quoteTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteMint',
            accounts.quoteMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.associatedTokenProgram.value) {
    accounts.associatedTokenProgram.value =
      'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>;
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('beneficiary', accounts.beneficiary),
      getAccountMeta('rehypeState', accounts.rehypeState),
      getAccountMeta('rehypeAuthority', accounts.rehypeAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('routerBaseAta', accounts.routerBaseAta),
      getAccountMeta('routerQuoteAta', accounts.routerQuoteAta),
      getAccountMeta('beneficiaryBaseAta', accounts.beneficiaryBaseAta),
      getAccountMeta('beneficiaryQuoteAta', accounts.beneficiaryQuoteAta),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('associatedTokenProgram', accounts.associatedTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
    ],
    data: getClaimFeesInstructionDataEncoder().encode(
      args as ClaimFeesInstructionDataArgs,
    ),
    programAddress,
  } as ClaimFeesInstruction<
    TProgramAddress,
    TAccountPayer,
    TAccountBeneficiary,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBeneficiaryBaseAta,
    TAccountBeneficiaryQuoteAta,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram
  >);
}

export type ClaimFeesInput<
  TAccountPayer extends string = string,
  TAccountBeneficiary extends string = string,
  TAccountRehypeState extends string = string,
  TAccountRehypeAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountRouterBaseAta extends string = string,
  TAccountRouterQuoteAta extends string = string,
  TAccountBeneficiaryBaseAta extends string = string,
  TAccountBeneficiaryQuoteAta extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountAssociatedTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
> = {
  payer: TransactionSigner<TAccountPayer>;
  beneficiary: Address<TAccountBeneficiary>;
  rehypeState: Address<TAccountRehypeState>;
  rehypeAuthority: Address<TAccountRehypeAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  routerBaseAta: Address<TAccountRouterBaseAta>;
  routerQuoteAta: Address<TAccountRouterQuoteAta>;
  beneficiaryBaseAta: Address<TAccountBeneficiaryBaseAta>;
  beneficiaryQuoteAta: Address<TAccountBeneficiaryQuoteAta>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  associatedTokenProgram?: Address<TAccountAssociatedTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  beneficiaryIndex: ClaimFeesInstructionDataArgs['beneficiaryIndex'];
};

export function getClaimFeesInstruction<
  TAccountPayer extends string,
  TAccountBeneficiary extends string,
  TAccountRehypeState extends string,
  TAccountRehypeAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountRouterBaseAta extends string,
  TAccountRouterQuoteAta extends string,
  TAccountBeneficiaryBaseAta extends string,
  TAccountBeneficiaryQuoteAta extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountAssociatedTokenProgram extends string,
  TAccountSystemProgram extends string,
  TProgramAddress extends Address =
    typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
>(
  input: ClaimFeesInput<
    TAccountPayer,
    TAccountBeneficiary,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBeneficiaryBaseAta,
    TAccountBeneficiaryQuoteAta,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram
  >,
  config?: { programAddress?: TProgramAddress },
): ClaimFeesInstruction<
  TProgramAddress,
  TAccountPayer,
  TAccountBeneficiary,
  TAccountRehypeState,
  TAccountRehypeAuthority,
  TAccountBaseMint,
  TAccountQuoteMint,
  TAccountRouterBaseAta,
  TAccountRouterQuoteAta,
  TAccountBeneficiaryBaseAta,
  TAccountBeneficiaryQuoteAta,
  TAccountBaseTokenProgram,
  TAccountQuoteTokenProgram,
  TAccountAssociatedTokenProgram,
  TAccountSystemProgram
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    payer: { value: input.payer ?? null, isWritable: true },
    beneficiary: { value: input.beneficiary ?? null, isWritable: false },
    rehypeState: { value: input.rehypeState ?? null, isWritable: true },
    rehypeAuthority: {
      value: input.rehypeAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    routerBaseAta: { value: input.routerBaseAta ?? null, isWritable: true },
    routerQuoteAta: { value: input.routerQuoteAta ?? null, isWritable: true },
    beneficiaryBaseAta: {
      value: input.beneficiaryBaseAta ?? null,
      isWritable: true,
    },
    beneficiaryQuoteAta: {
      value: input.beneficiaryQuoteAta ?? null,
      isWritable: true,
    },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    associatedTokenProgram: {
      value: input.associatedTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.associatedTokenProgram.value) {
    accounts.associatedTokenProgram.value =
      'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>;
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('beneficiary', accounts.beneficiary),
      getAccountMeta('rehypeState', accounts.rehypeState),
      getAccountMeta('rehypeAuthority', accounts.rehypeAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('routerBaseAta', accounts.routerBaseAta),
      getAccountMeta('routerQuoteAta', accounts.routerQuoteAta),
      getAccountMeta('beneficiaryBaseAta', accounts.beneficiaryBaseAta),
      getAccountMeta('beneficiaryQuoteAta', accounts.beneficiaryQuoteAta),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('associatedTokenProgram', accounts.associatedTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
    ],
    data: getClaimFeesInstructionDataEncoder().encode(
      args as ClaimFeesInstructionDataArgs,
    ),
    programAddress,
  } as ClaimFeesInstruction<
    TProgramAddress,
    TAccountPayer,
    TAccountBeneficiary,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBeneficiaryBaseAta,
    TAccountBeneficiaryQuoteAta,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram
  >);
}

export type ParsedClaimFeesInstruction<
  TProgram extends string = typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    payer: TAccountMetas[0];
    beneficiary: TAccountMetas[1];
    rehypeState: TAccountMetas[2];
    rehypeAuthority: TAccountMetas[3];
    baseMint: TAccountMetas[4];
    quoteMint: TAccountMetas[5];
    routerBaseAta: TAccountMetas[6];
    routerQuoteAta: TAccountMetas[7];
    beneficiaryBaseAta: TAccountMetas[8];
    beneficiaryQuoteAta: TAccountMetas[9];
    baseTokenProgram: TAccountMetas[10];
    quoteTokenProgram: TAccountMetas[11];
    associatedTokenProgram: TAccountMetas[12];
    systemProgram: TAccountMetas[13];
  };
  data: ClaimFeesInstructionData;
};

export function parseClaimFeesInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedClaimFeesInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 14) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 14,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      payer: getNextAccount(),
      beneficiary: getNextAccount(),
      rehypeState: getNextAccount(),
      rehypeAuthority: getNextAccount(),
      baseMint: getNextAccount(),
      quoteMint: getNextAccount(),
      routerBaseAta: getNextAccount(),
      routerQuoteAta: getNextAccount(),
      beneficiaryBaseAta: getNextAccount(),
      beneficiaryQuoteAta: getNextAccount(),
      baseTokenProgram: getNextAccount(),
      quoteTokenProgram: getNextAccount(),
      associatedTokenProgram: getNextAccount(),
      systemProgram: getNextAccount(),
    },
    data: getClaimFeesInstructionDataDecoder().decode(instruction.data),
  };
}
